export const transactionsSearchFields = {
    // "S/N": "posTerminal",
    "RRN": "rrn",
    "Terminal ID": "terminalId",
    "Merchant ID": "merchantId",
    "Amount": "amount",
    // "Status": "statusCode",
};